import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-update-variazione-sottostante-appo-table',
  templateUrl: './confirm-update-variazione-sottostante-appo-table.component.html',
  styleUrls: []
})
export class ConfirmUpdateVariazioneSottostanteAppoTableComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<boolean>) { }

  ngOnInit(): void {
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
